import React from 'react';

export const AstraVerification = () => {
  return <div>b3959ca2abe2844c7c19</div>;
};
